export const PROMPT_CREATION_PAGE_VALIDATION_MISSING_NAME = {
  title: "Prompt name required",
  message: "You must enter a name to save the prompt. Without a name, the process cannot be completed. Please add a name and try again."
};

export const PROMPT_CREATION_PAGE_VALIDATION_MISSING_CONTENT = {
  title: "Prompt content required",
  message: "You must enter a prompt before saving. Without a prompt, the process cannot be completed. Please add one and try again."
};

export const PROMPT_CREATION_PAGE_VALIDATION_NAME_ALREADY_EXISTS = {
  title: "Duplicate prompt name detected",
  message: "This prompt name has already been used. Please choose a different name, as duplicate names are not allowed."
};

export const PROMPT_CREATION_PAGE_VALIDATION_CREATED_SUCCESS = {
  title: "Prompt created successfully",
  message: "Your prompt has been successfully created and is now ready for use. You can select and activate it anytime."
};

export const PROMPT_CREATION_PAGE_VALIDATION_UPDATED_SUCCESS = {
  title: "Prompt successfully updated",
  message: "Your prompt has been updated and is now ready for use. You can select and activate it at any time."
};

export const PROMPT_MODAL_CONFIRMATION_DELETE = {
  title: "Confirm prompt deletion",
  message: "This action is permanent and cannot be undone. Are you sure you want to delete this prompt?",
};

export const PROMPT_MODAL_CONFIRMATION_DELETE_SUCCESS = {
  title: "Prompt deleted",
  message: "The prompt has been successfully deleted. This action is permanent and cannot be undone.",
}
